"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _arEG = _interopRequireDefault(require("./ar-EG.json"));

var _arJO = _interopRequireDefault(require("./ar-JO.json"));

var _arSA = _interopRequireDefault(require("./ar-SA.json"));

var _bgBG = _interopRequireDefault(require("./bg-BG.json"));

var _caES = _interopRequireDefault(require("./ca-ES.json"));

var _csCZ = _interopRequireDefault(require("./cs-CZ.json"));

var _daDK = _interopRequireDefault(require("./da-DK.json"));

var _deDE = _interopRequireDefault(require("./de-DE.json"));

var _elGR = _interopRequireDefault(require("./el-GR.json"));

var _enUS = _interopRequireDefault(require("./en-US.json"));

var _esES = _interopRequireDefault(require("./es-ES.json"));

var _etEE = _interopRequireDefault(require("./et-EE.json"));

var _euES = _interopRequireDefault(require("./eu-ES.json"));

var _fiFI = _interopRequireDefault(require("./fi-FI.json"));

var _frFR = _interopRequireDefault(require("./fr-FR.json"));

var _glES = _interopRequireDefault(require("./gl-ES.json"));

var _heIL = _interopRequireDefault(require("./he-IL.json"));

var _hiIN = _interopRequireDefault(require("./hi-IN.json"));

var _hrHR = _interopRequireDefault(require("./hr-HR.json"));

var _huHU = _interopRequireDefault(require("./hu-HU.json"));

var _idID = _interopRequireDefault(require("./id-ID.json"));

var _itIT = _interopRequireDefault(require("./it-IT.json"));

var _jaJP = _interopRequireDefault(require("./ja-JP.json"));

var _kkKZ = _interopRequireDefault(require("./kk-KZ.json"));

var _koKR = _interopRequireDefault(require("./ko-KR.json"));

var _ltLT = _interopRequireDefault(require("./lt-LT.json"));

var _lvLV = _interopRequireDefault(require("./lv-LV.json"));

var _msMY = _interopRequireDefault(require("./ms-MY.json"));

var _nbNO = _interopRequireDefault(require("./nb-NO.json"));

var _nlNL = _interopRequireDefault(require("./nl-NL.json"));

var _plPL = _interopRequireDefault(require("./pl-PL.json"));

var _ptBR = _interopRequireDefault(require("./pt-BR.json"));

var _ptPT = _interopRequireDefault(require("./pt-PT.json"));

var _roRO = _interopRequireDefault(require("./ro-RO.json"));

var _ruRU = _interopRequireDefault(require("./ru-RU.json"));

var _skSK = _interopRequireDefault(require("./sk-SK.json"));

var _slSI = _interopRequireDefault(require("./sl-SI.json"));

var _srCyrlCS = _interopRequireDefault(require("./sr-Cyrl-CS.json"));

var _srLatnCS = _interopRequireDefault(require("./sr-Latn-CS.json"));

var _svSE = _interopRequireDefault(require("./sv-SE.json"));

var _thTH = _interopRequireDefault(require("./th-TH.json"));

var _trTR = _interopRequireDefault(require("./tr-TR.json"));

var _ukUA = _interopRequireDefault(require("./uk-UA.json"));

var _viVN = _interopRequireDefault(require("./vi-VN.json"));

var _yue = _interopRequireDefault(require("./yue.json"));

var _zhCN = _interopRequireDefault(require("./zh-CN.json"));

var _zhHK = _interopRequireDefault(require("./zh-HK.json"));

var _zhTW = _interopRequireDefault(require("./zh-TW.json"));

var _overrides = _interopRequireDefault(require("./overrides.json"));

var _mergeLocalizedStrings = _interopRequireDefault(require("./mergeLocalizedStrings"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Strings commented out are pending official translations


var localizedStrings;

function getAllLocalizedStrings() {
  return localizedStrings || (localizedStrings = (0, _mergeLocalizedStrings.default)({
    'ar-EG': _arEG.default,
    'ar-JO': _arJO.default,
    'ar-SA': _arSA.default,
    'bg-BG': _bgBG.default,
    'ca-ES': _caES.default,
    'cs-CZ': _csCZ.default,
    'da-DK': _daDK.default,
    'de-DE': _deDE.default,
    'el-GR': _elGR.default,
    'en-US': _enUS.default,
    'es-ES': _esES.default,
    'et-EE': _etEE.default,
    'eu-ES': _euES.default,
    'fi-FI': _fiFI.default,
    'fr-FR': _frFR.default,
    'gl-ES': _glES.default,
    'he-IL': _heIL.default,
    'hi-IN': _hiIN.default,
    'hr-HR': _hrHR.default,
    'hu-HU': _huHU.default,
    'id-ID': _idID.default,
    'it-IT': _itIT.default,
    'ja-JP': _jaJP.default,
    'kk-KZ': _kkKZ.default,
    'ko-KR': _koKR.default,
    'lt-LT': _ltLT.default,
    'lv-LV': _lvLV.default,
    'ms-MY': _msMY.default,
    'nb-NO': _nbNO.default,
    'nl-NL': _nlNL.default,
    'pl-PL': _plPL.default,
    'pt-BR': _ptBR.default,
    'pt-PT': _ptPT.default,
    'ro-RO': _roRO.default,
    'ru-RU': _ruRU.default,
    'sk-SK': _skSK.default,
    'sl-SI': _slSI.default,
    'sr-Cyrl': _srCyrlCS.default,
    'sr-Latn': _srLatnCS.default,
    'sv-SE': _svSE.default,
    'th-TH': _thTH.default,
    'tr-TR': _trTR.default,
    'uk-UA': _ukUA.default,
    'vi-VN': _viVN.default,
    yue: _yue.default,
    'zh-Hans': _zhCN.default,
    'zh-Hant': _zhTW.default,
    'zh-Hans-SG': _zhCN.default,
    'zh-Hant-HK': _zhHK.default,
    'zh-Hant-MO': _zhTW.default
  }, _overrides.default));
}

var _default = getAllLocalizedStrings;
exports.default = _default;